import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import type { ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Button } from "@/designSystem/components/button"
import { Section } from "@/designSystem/patterns/section"
import { useI18nContext } from "@/i18n/i18n-solid"
import { Well } from "./well"

type Props = {
  title: string
  description: string
  hue: AccentHue
  iconName: IconName
  onSubmit?: () => void
  id?: string
} & ParentProps
export function Form(props: Props) {
  return (
    <Section
      title={props.title}
      description={props.description}
      hue={props.hue}
      id={props.id}
      iconName={props.iconName}
    >
      <form
        onSubmit={e => {
          e.preventDefault()
          e.stopPropagation()
          props.onSubmit?.()
        }}
      >
        <Well>{props.children}</Well>
      </form>
    </Section>
  )
}

type SaveButtonProps = {
  disabled?: boolean
  active?: boolean
  hue: AccentHue
  iconName?: IconName
  label?: string
}
function Save(props: SaveButtonProps) {
  const { LL } = useI18nContext()

  return (
    <Box justifyContent="flex-end" flexDirection="row" gap="8">
      <Button
        hue={props.hue}
        iconName={props.iconName}
        type="submit"
        disabled={props.disabled}
        active={props.active}
      >
        {props.label || LL().common.save()}
      </Button>
    </Box>
  )
}

Form.Save = Save
